<template lang="pug">
div
  section
    AppTitle.u-mb-md(:title="$t('mantra')")

    div(v-if="$i18n.locale === 'en'")
      Content.is-normal
        h2 Baianat's privacy updates policy
        p Baianat has the right at any time review and improve the privacy policy and provide notification of any amendments in this post. Therefore, to keep up to with any recent policy amendments, customers are kindly requested to pay a visit to this page and check the latest edition of privacy policy. Customers are welcomed to contact Baianat call center to ask about any amendments to the policy
    div(v-else)
      Content.is-normal
        h2 سياسية بيانات لتحديثات الخصوصية
        p يحق لشركة بيانات في أي وقت مراجعة وتحسين سياسة الخصوصية الخاصة بها، وتقديم إشعارًا بأي تعديلات من خلال هذا المنشور. لذلك، لتكون مواكبًا لأي تعديلات في سياسة الخصوصية، نطلب من عملائنا زيارة هذه الصفحة باستمرار  و التحقق الدائم من الاصدار الأخير من سياسية الخصوصية. نرحب باتصال العملاء عبر مركز الاتصال الخاص ببيانات للسؤال عن أي تعديلات في السياسة.

</template>

<script>
import Content from '@/components/Content';
import { generateSeoMeta } from '~/utils/seo';

export default {
  scrollToTop: true,
  head: generateSeoMeta(
    {
      title: 'pageTitle',
      description: 'pageDesc'
    },
    { i18n: true }
  ),
  components: {
    Content
  }
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"Privacy Updates",
    "pageDesc":"Our privacy policy last updates including the major changes that are related to your experience on our website.",
    "mantra":"Privacy |updates."
  },
  "ar": {
    "pageTitle":"تحديثات الخصوصية",
    "pageDesc":"توضح كل تحديثات سياسة الخصوصية التى تتعلق بشأن التغييرات الرئيسية التي تتم على الموقع وتتعلق بتجربتك أثناء عملية تصفحه.",
    "mantra":"تحديثات |الخصوصية"
  }
}
</i18n>
